<template>
  <div class="account-select">
    <el-dropdown
      v-if="!disabled"
      trigger="click"
      @command="changeAccount"
      :show-timeout="100"
      :hide-timeout="100"
      placement="bottom-start"
    >
      <div class="account-item">
        <icon
          class="icon"
          :name="selectedAccount.name"
          :pictureUrl="selectedAccount.pictureUrl"
          :iconType="selectedAccount.snsType"
        ></icon
        ><span>{{ selectedAccount.name }}</span
        ><i class="mdi mdi-menu-down"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="account in accounts"
          :key="account.id"
          :command="account.id"
          :class="{ active: account.id === selectedAccount.id }"
        >
          <div class="account-item">
            <icon class="icon" :name="account.name" :pictureUrl="account.pictureUrl" :iconType="account.snsType"></icon
            >{{ account.name }}
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="account-item disabled" v-else>
      <icon
        class="icon"
        :name="selectedAccount.name"
        :pictureUrl="selectedAccount.pictureUrl"
        :iconType="selectedAccount.snsType"
      ></icon
      ><span>{{ selectedAccount.name }}</span
      ><i class="mdi mdi-menu-down"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.el-dropdown {
  border: 1px solid $border-color;
  border-radius: $round;
}

.account-item {
  padding: $spacing-unit;
  cursor: pointer;

  .icon {
    margin-right: $spacing-unit;
  }

  .mdi-menu-down {
    margin-left: $spacing-unit;
  }

  &.disabled {
    display: inline-block;
    color: $disabled-color;
    cursor: no-drop;
    border: 1px solid $border-color;
    border-radius: $round;
  }
}

.el-dropdown-menu {
  max-height: 50 * $spacing-unit;
  overflow-y: auto;

  .account-item {
    padding: $spacing-unit 0;
  }
}

.el-dropdown-menu__item.active,
.el-dropdown-menu__item:hover {
  color: rgba($primary-color, 0.8);
  background-color: rgba($primary-color, 0.1);
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
export default defineComponent({
  components: {
    Icon
  },
  props: {
    selectedAccountId: Number,
    accounts: Array,
    onChange: Function,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.setSelectedAccount()
  },
  data() {
    return {
      selectedAccount: {},
      currentAccountId: this.selectedAccountId
    }
  },
  watch: {
    selectedAccountId() {
      this.currentAccountId = this.selectedAccountId
      this.setSelectedAccount()
    }
  },
  methods: {
    /**
     * アカウント変更
     * @param {string} accountId アカウントID
     */
    changeAccount(accountId: string) {
      this.currentAccountId = accountId
      this.setSelectedAccount()
      if (typeof this.onChange === 'function') {
        this.onChange(this.currentAccountId)
      }
    },
    /**
     * 選択したアカウントをセット
     */
    setSelectedAccount() {
      if (!this.currentAccountId) {
        this.selectedAccount = this.accounts[0]
      } else {
        let selectedAccount = this.accounts.find(account => {
          return account.id === this.currentAccountId
        })
        if (!selectedAccount) {
          selectedAccount = this.accounts[0]
        }
        this.selectedAccount = selectedAccount
      }
    }
  }
})
</script>
